import { render, staticRenderFns } from "./personalKnowledgeBase.vue?vue&type=template&id=3c778727&scoped=true&"
import script from "./personalKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./personalKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./personalKnowledgeBase.vue?vue&type=style&index=0&id=3c778727&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c778727",
  null
  
)

export default component.exports